import React, { useState, useEffect, useRef } from "react";
import HeaderEntreprise from "../../header/headerEntreprise";
import ProfileForm from "../../commun/ProfileForm";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Avatar, Typography, Container, Tabs, Tab, Card, CardContent, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, } from "@mui/material";
import CustomAlert from "../../commun/CustomAlert";
import Footer from '../../commun/Footer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import LoadingPopup from "../../commun/LoadingPopup";
import './ProfilEntreprise.css';
import { DeleteIcon, EditIcon } from "lucide-react";
import { showDeleteConfirmation } from "../../commun/deletemsg";
import PhoneInput from "react-phone-input-2";

const ProfilEntreprise = () => {
  const navigate = useNavigate();
  const entrepriseName = localStorage.getItem("entrepriseName");
  const userId = localStorage.getItem("userId");
  const id = localStorage.getItem("entrepriseId");
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [utilisateursAdditionnels, setUtilisateursAdditionnels] = useState([]);
  const fileInputRef = useRef(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [openAddUser, setOpenAddUser] = useState(false);
  const [newUser, setNewUser] = useState({
    firstName: "", lastName: "", email: "", phone: "", motDePasse: ""
  });
  const [errors, setErrors] = useState({});
  const [isEditingUser, setIsEditingUser] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  
  const setField = (name, value) =>
    setFormData(prev => ({ ...prev, [name]: value }));

  const showMessage = (message, severity = "info") => {
      setAlertMessage(message);
      setAlertSeverity(severity);
      setAlertOpen(true);
    };

  const handleGeneratePassword = () => {
    const characters = "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    const pwd = Array.from({ length: 10 }, () => characters[Math.floor(Math.random() * characters.length)]).join('');
    setNewUser(prev => ({ ...prev, motDePasse: pwd }));
  };

  const handleAddUser = async () => {
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(`${API_BASE}/api/entreprise/${formData._id}/ajouter-utilisateur`, newUser, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAlertMessage("Utilisateur ajouté avec succès.");
      setAlertSeverity("success");
      setAlertOpen(true);
      setOpenAddUser(false);
      setNewUser({ firstName: "", lastName: "", email: "", phone: "", motDePasse: "" });
      fetchEntrepriseData();
    } catch (err) {
      setAlertMessage(err.response?.data?.message || "Erreur lors de l'ajout.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };
  
  const [formData, setFormData] = useState({
    NomEntreprise: "",
    logo: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    fonction: "",
    siteWeb: "",
    description: "",
    adresse: "",
    ice: "",
    sector: "",
    tranche: "",
    utilisateur: {
      _id: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      photo: ""
    }
  });

  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

const fetchEntrepriseData = async () => {
  try {
    const token = localStorage.getItem("authToken");
    if (!token || !userId) return navigate("/");

    const res = await axios.get(`${API_BASE}/api/entreprise/profil/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const entreprise = res.data;
    setFormData({
      ...entreprise,
      utilisateur: entreprise.utilisateur || { _id: "", firstName: "", lastName: "", email: "", phone: "", photo: "" }
    });

    setUtilisateursAdditionnels(entreprise.utilisateursAdditionnels || []);

    if (entreprise.logo) {
      localStorage.setItem("entrepriseLogo", entreprise.logo);
    }

    setIsLoading(false);
  } catch (error) {
    console.error("Erreur récupération données :", error);
    setIsLoading(false);
  }
};


  useEffect(() => {
    fetchEntrepriseData();
  }, []);

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token || !userId) return navigate("/");

      const updatedData = {
        sector: formData.sector || "",
        ice: formData.ice || "",
        description: formData.description || "",
        adresse: formData.adresse || "",
        fonction: formData.fonction || "",
        siteWeb: formData.siteWeb || "",
        tranche: formData.tranche || "",
        utilisateur: {
          _id: formData.utilisateur._id,
          firstName: formData.utilisateur.firstName || "",
          lastName: formData.utilisateur.lastName || "",
          email: formData.utilisateur.email || "",
          phone: formData.utilisateur.phone || "",
          receiveMail: formData.utilisateur.receiveMail || false
        }
      };
      await axios.patch(`${API_BASE}/api/entreprise/edit/${userId}`, updatedData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setAlertMessage("Informations mises à jour avec succès.");
      setAlertSeverity("success");
      setAlertOpen(true);
      setIsEditing(false);
    } catch (error) {
      setAlertMessage(error.response?.data?.message || "Erreur mise à jour.");
      setAlertSeverity("error");
      setAlertOpen(true);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // Vérifier si l'image est carrée
    const img = new Image();
    img.src = URL.createObjectURL(file);
  
    img.onload = async () => {
      if (img.width !== img.height) {
        setAlertMessage("Veuillez choisir une image carrée.");
        setAlertSeverity("error");
        setAlertOpen(true);
        return;
      }
  
      const token = localStorage.getItem("authToken");
      const form = new FormData();
      form.append("file", file);
  
      try {
        let url;
        if (activeTab === 0) {
          url = `${API_BASE}/api/entreprise/logo/${formData._id || userId}`;
        } else {
          url = `${API_BASE}/api/entreprise/upload-interlocuteur-photo/${formData.utilisateur._id}`;
        }
  
        const res = await axios.post(url, form, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
  
        if (activeTab === 0) {
          setFormData(prev => ({ ...prev, logo: res.data.logo }));
          localStorage.setItem("entrepriseLogo", res.data.logo);
          window.dispatchEvent(new Event("storage"));
          setAlertMessage("Logo mis à jour.");
        } else {
          setFormData(prev => ({
            ...prev,
            utilisateur: {
              ...prev.utilisateur,
              photo: res.data.photo
            }
          }));
          setAlertMessage("Photo interlocuteur mise à jour.");
        }
  
        setAlertSeverity("success");
        setAlertOpen(true);
      } catch (err) {
        console.error("Erreur upload fichier:", err);
        setAlertMessage("Erreur lors du téléversement.");
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    };
  };
  

  if (isLoading) return 
    <LoadingPopup
        open={!isLoading}
        message="Chargement..."
      />
    ;

  const entrepriseFields = [
    { label: "Adresse", name: "adresse", grid: { xs: 12, sm: 6 } },
    { label: "ICE", name: "ice", grid: { xs: 12, sm: 6 } },
    { label: "Tranche d'effectif", name: "tranche", grid: { xs: 12, sm: 6 } },
    { label: "Secteur d'activité", name: "sector", grid: { xs: 12, sm: 6 } },
    { label: "Description", name: "description", multiline: true, grid: { xs: 12, sm: 6 } }
  ];

  const interlocuteurFields = [
    { label: "Nom", name: "utilisateur.lastName" },
    { label: "Prénom", name: "utilisateur.firstName" },
    { label: "Téléphone", name: "utilisateur.phone" },
    { label: "Email", name: "utilisateur.email", type: "email" }
  ];

  const avatarSrc =
  activeTab === 0
    ? formData.logo
      ? `${API_BASE}${formData.logo}?${new Date().getTime()}`
      : undefined
    : formData.utilisateur?.photo
      ? `${API_BASE}${formData.utilisateur.photo}?${new Date().getTime()}`
      : undefined;
const handleToggleStatus = async (userId) => {
  try {
    const token = localStorage.getItem("authToken");
    const res = await axios.put(`${API_BASE}/api/entreprise/toggle-user-status/${userId}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setAlertMessage(res.data.message);
    setAlertSeverity("success");
    setAlertOpen(true);
    fetchEntrepriseData();
  } catch (err) {
    setAlertMessage("Erreur lors du changement d'état.");
    setAlertSeverity("error");
    setAlertOpen(true);
  }
};

const handleApproval = async (userId, decision) => {
  try {
    const token = localStorage.getItem("authToken");
    const res = await axios.put(`${API_BASE}/api/entreprise/approve-user/${userId}`, { decision }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setAlertMessage(res.data.message);
    setAlertSeverity("success");
    setAlertOpen(true);
    fetchEntrepriseData(); // recharge la liste
  } catch (err) {
    setAlertMessage("Erreur lors de l'approbation/refus.");
    setAlertSeverity("error");
    setAlertOpen(true);
  }
};
if (!formData.utilisateur || !formData.utilisateur._id) return null;
const isUserPrincipal = localStorage.getItem("isUserPrincipal") === "true";

const handlePasswordChange = async (newPassword) => {
  handleSave();
};

    const handleDeleteUser = (userId) => {
      showDeleteConfirmation({
        onConfirm: async () => {
          try {
            await axios.delete(`${API_BASE}/api/entreprise/${id}/utilisateur/${userId}`);
            showMessage("Utilisateur supprimé avec succès.", "success");
            fetchEntrepriseData();
          } catch (err) {
            showMessage("Erreur lors de la suppression.", "error");
          }
        },
        onCancel: () => {
          showMessage("Suppression annulée.", "info");
        }
      });
    };

    const handleOpenEditUser = (user) => {
      setIsEditingUser(true);
      setEditingUserId(user._id);
      setNewUser({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        phone: user.phone || "",
        motDePasse: "" 
      });
      setOpenAddUser(true);
    };

    const handleEditUser = async () => {
      try {
        const token = localStorage.getItem("authToken");
        await axios.put(
          `${API_BASE}/api/entreprise/${id}/edit-contributeur/${editingUserId}`,
          newUser,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        showMessage("Utilisateur mis à jour avec succès.", "success");
        setOpenAddUser(false);
        setIsEditingUser(false);
        setEditingUserId(null);
        fetchEntrepriseData(); 
      } catch (err) {
        showMessage("Erreur lors de la mise à jour.", "error");
      }
    };


  return (
    <div>
      <HeaderEntreprise entrepriseName={entrepriseName} />

      <div className="profile-header">
        <div className="profile-avatar-wrapper">
          <Avatar
            src={avatarSrc}
            alt={activeTab === 0 ? 'Logo entreprise' : 'Photo interlocuteur'}
            className={`profile-avatar ${activeTab === 1 ? 'user' : ''} logo-image`}
          >
            {activeTab === 1 &&
              (!formData.utilisateur.firstName && !formData.utilisateur.lastName)
              ? null
              : `${(formData.utilisateur.firstName || '').charAt(0)}${(formData.utilisateur.lastName || '').charAt(0)}`}
          </Avatar>

          <div className="profile-name">
            {activeTab === 0
              ? formData.NomEntreprise || "Nom entreprise"
              : `${formData.utilisateur.firstName || ''} ${formData.utilisateur.lastName || ''}`.trim()}
          </div>

          <div>
            <Button onClick={() => fileInputRef.current.click()} className="upload-btn">
              {activeTab === 0 ? "Changer le logo" : "Changer la photo"}
            </Button>
            <input
              type="file"
              accept="image/*"
              hidden
              ref={fileInputRef}
              onChange={handleFileUpload}
            />
          </div>
        </div>
      </div>
      <section className="profile-container">
      <Container maxWidth="md">
        <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)} centered>
          <Tab label="Entreprise" />
          <Tab label="Interlocuteur" />
        </Tabs>

        <Card variant="outlined">
          <CardContent>
            {activeTab === 0 ? (
              <ProfileForm
                title="Informations sur l'entreprise"
                formData={formData}
                setFormData={setFormData}
                fields={entrepriseFields}
                isEditing={isEditing}
                onSave={handleSave}
                onToggleEdit={() => setIsEditing(!isEditing)}
                onChangePassword={handlePasswordChange}
              />
            ) : (
              <ProfileForm
                title={`${isUserPrincipal ? ' Utilisateur principal' : 'Contributeur '}`}
                formData={formData}
                setFormData={setFormData}
                fields={interlocuteurFields}
                isEditing={isEditing}
                onSave={handleSave}
                onToggleEdit={() => setIsEditing(!isEditing)}
                isInterlocuteurTab
                onChangePassword={handlePasswordChange}
              />
              
            )}
            {activeTab === 0 && utilisateursAdditionnels.length > 0 && (
          <div className="user-list-section">
            <h3>Contributeurs</h3>
            {isUserPrincipal && (
              <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setOpenAddUser(true)}>
                Ajouter un utilisateur
              </Button>
            )}

          <ul className="user-list">

        {utilisateursAdditionnels.map((user) => (
        <li key={user._id} className="user-item" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 0',
          borderBottom: '1px solid #ddd'
        }}>
          <div>
            <strong>{user.firstName} {user.lastName}</strong> — {user.email} — {user.phone}
          </div>

  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    {/* Icône + label statut */}
    {user.statut === "active" ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <CheckCircleIcon style={{ color: 'green' }} titleAccess="Compte actif" />
        <Typography variant="body2" color="green">Actif</Typography>
      </div>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <BlockIcon style={{ color: 'red' }} titleAccess="Compte bloqué ou en attente" />
        <Typography variant="body2" color="red">En attente</Typography>
      </div>
    )}
{isUserPrincipal && (
  <>
    <Button
      variant="outlined"
      size="small"
      color={user.statut === "active" ? "warning" : "success"}
      onClick={() => handleToggleStatus(user._id)}
    >
      {user.statut === "active" ? "Désactiver" : "Activer"}
    </Button>
    <IconButton onClick={() => handleDeleteUser(user._id)} color="error">
      <DeleteIcon />
    </IconButton>
    <IconButton
      color="primary"
      onClick={() => handleOpenEditUser(user)}
    >
      <EditIcon />
    </IconButton>

    {user.statut === "pending" && (
      <>
        <Button
          variant="contained"
          size="small"
          color="success"
          onClick={() => handleApproval(user._id, "approve")}
        >
          Approuver
        </Button>
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={() => handleApproval(user._id, "refuse")}
        >
          Refuser
        </Button>
      </>
    )}
  </>
)}

      
  </div>
</li>


        ))}
      </ul>
      <Dialog open={openAddUser} onClose={() => setOpenAddUser(false)} fullWidth>
          <DialogTitle>{isEditingUser ? "Modifier l'utilisateur" : "Ajouter un utilisateur"}</DialogTitle>
          <DialogContent>
            <TextField
              label="Nom"
              fullWidth
              margin="dense"
              value={newUser.lastName}
              onChange={(e) => setNewUser({ ...newUser, lastName: e.target.value })}
            />
            <TextField
              label="Prénom"
              fullWidth
              margin="dense"
              value={newUser.firstName}
              onChange={(e) => setNewUser({ ...newUser, firstName: e.target.value })}
            />
            <TextField
              label="Email"
              fullWidth
              margin="dense"
              value={newUser.email}
              onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
            />

            <Box>
              <PhoneInput
                country="fr"
                onlyCountries={["fr", "ma", "tn"]}
                value={newUser.phone}
                onChange={(value) => {
                  const fullNumber = value.startsWith("+") ? value : `+${value}`;
                  setNewUser({ ...newUser, phone: fullNumber });
                }}
                inputStyle={{ width: "100%", height: 50 }}
              />

              {errors?.phone && <p style={{ color: "red" }}>{errors.phone}</p>}
            </Box>
            <TextField
              label="Mot de passe"
              fullWidth
              margin="dense"
              value={newUser.motDePasse}
              onChange={(e) => setNewUser({ ...newUser, motDePasse: e.target.value })}
            />
            <Button size="small" onClick={handleGeneratePassword} sx={{ mt: 1 }}>
              Générer mot de passe
            </Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenAddUser(false)}>Annuler</Button>
            <Button
              onClick={isEditingUser ? handleEditUser : handleAddUser}
              variant="contained"
            >
              {isEditingUser ? "Enregistrer" : "Ajouter"}
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    )}

          </CardContent>
        </Card>
      </Container>
    </section>
      <Footer />

      <CustomAlert
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        onClose={() => setAlertOpen(false)}
      />
    </div>
  );
};

export default ProfilEntreprise;
